<template>
  <div v-if="retailerId === 'SOF'" class="wrapper">
    <div class="sof-jumbotron">
      <h2 class="sof-jumbotron__title">Get ready for your delivery</h2>
      <ul class="sof-list">
        <li class="sof-list__item">
          <img class="sof-list__item__image" alt="" src="./../assets/img/sof_thumb1.png" />
          <h4 class="sof-list__item__title">1. Plan the <span class="line-break-md"></span>route</h4>
          Once you have the measurements, plan the easiest route into your room.
        </li>
        <li class="sof-list__item">
          <img class="sof-list__item__image" alt="" src="./../assets/img/sof_thumb2.png" />
          <h4 class="sof-list__item__title">2. Make some <span class="line-break-md"></span>space</h4>
          Clear the route and move any valuables out of the way to ensure a smooth delivery.
        </li>
        <li class="sof-list__item">
          <img class="sof-list__item__image" alt="" src="./../assets/img/sof_thumb3.png" />
          <h4 class="sof-list__item__title">3. Leave it to the <span class="line-break-md"></span>professionals</h4>
          Our delivery teams will take good care of your sofa. We will also remove all packaging.
        </li>
        <li class="sof-list__item">
          <img class="sof-list__item__image" alt="" src="./../assets/img/sof_thumb4.png" />
          <h4 class="sof-list__item__title">4. Inspect <span class="line-break-md"></span>and...relax!</h4>
          Check over your new sofa and make sure to ask any questions whilst the team is still there.
        </li>
      </ul>
    </div>
    <div class="sof-contact">
      <h2 class="sof-contact__title">Need to talk about your order?</h2>
      <span>Call us on <a href="tel:03444 81 81 81">03444 81 81 81</a></span>
    </div>
  </div>

  <div v-else class="highlighted-box covid-statement">
    <div class="highlighted-box__header">3 simple steps for a smooth furniture delivery</div>
    <hr />
    <p class="text text--align-center">In order to ensure a successful and safe delivery experience please prepare and adhere to the following:</p> 
    <div class="box-container">
      <div class="highlighted-box__item">
        <div class="highlighted-box__item__image" :style="{backgroundImage:'url(thumb1_covid.png)'}"></div>
        <div class="highlighted-box__item__text">
          <div class="text">Please ensure you remain a minimum of 2m away from our installation team, ideally in another room</div>
        </div>
      </div>
      <div class="highlighted-box__item">
        <div class="highlighted-box__item__image" :style="{backgroundImage:'url(thumb2_covid.jpg)'}"></div>
        <div class="highlighted-box__item__text">
          <div class="text">Please ensure you have opened windows in your room of choice</div>
        </div>
      </div>
      <div class="highlighted-box__item">
        <div class="highlighted-box__item__image" :style="{backgroundImage:'url(thumb3_covid.png)'}"></div>
        <div class="highlighted-box__item__text">
          <div class="text">We would appreciate if you could wear a mask during delivery as our delivery teams will be</div>
        </div>
      </div>
    </div>
    <p class="covid-statement__emphasis">Please adhere to these requirements to ensure that we can deliver safely for both you and our colleagues</p>
    <div class="text text--big-lineheight text--align-center">
      <strong>Need to speak to us about your delivery?</strong>
      <div> If you have any questions or issues with this delivery, or you will no longer be home, please contact us on</div>
      <div>
        <a href="tel:0800 110 5000">0800 110 5000</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DeliveryInstructions",
  props: ['retailerId']
}
</script>
<style lang="scss">
  .sof-jumbotron {
    text-align: center;
    background-color: #f5f5f5;
    padding: 40px 20px;
    border-radius: 16px;
    &__title {
      font-size: 20px;
      @media (min-width: 768px) {
        font-size: 24px;
      }
    }
  }
  .sof-list {
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    &__item {
      font-size: 13px;
      line-height: 1.2;
      padding: 25px;
      &__image {
        width: auto;
        height: 65px;
      }
      &__title {
        font-size: 18px;
        margin: 10px 0;
      }
    }
  }
  .sof-contact {
    text-align: center;
    font-size: 20px;
    margin: 50px 0;
    &__title {
      margin-bottom: 10px;
    }
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
</style>
